module.exports = __webpack_public_path__ + "media/stylesheets/opensans800-79c799e1f955d9e92b9b57418a923dbc.woff";